import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "mb-24" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_3 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-lg" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "flex xl:flex-row flex-col gap-3 items-start" }
const _hoisted_10 = { class: "w-full" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = { class: "flex flex-row" }
const _hoisted_13 = { class: "w-full xl:w-1/4" }
const _hoisted_14 = { class: "flex items-center cursor-pointer xl:mt-2" }
const _hoisted_15 = { class: "w-full xl:w-1/4" }
const _hoisted_16 = { class: "flex items-center cursor-pointer xl:mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "font-bold tracking-wider truncate text-single-line break-all leading-tight text-2xl mt-0" }, " Add New POS ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.addNew()), ["prevent"])),
              class: "h-10 hover:bg-theme-darkgreen border-0 hover:text-white rounded-md cursor-pointer text-green-400 bg-white py-2 px-4 uppercase"
            }, " SAVE "),
            _createElementVNode("span", {
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args)), ["prevent"])),
              class: "cursor-pointer rounded-md text-white py-2 pl-2 hover:opacity-70"
            }, "CLOSE")
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: _normalizeClass('input-wrapper ' + (_ctx.form.name.error_type))
                }, [
                  _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-xs mb-1" }, "Name:", -1)),
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "E.g. Samsung A7 Location #1",
                    onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.validateFields(['name']))),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.name.value) = $event)),
                    class: "block rounded bg-gray-black w-full",
                    type: "text"
                  }, null, 544), [
                    [_vModelText, _ctx.form.name.value]
                  ]),
                  (_ctx.form.name.error_message)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-error label-text mt-1",
                        textContent: _toDisplayString(_ctx.form.name.error_message)
                      }, null, 8, _hoisted_11))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs mb-1 mt-0" }, "Status:", -1)),
            _createElementVNode("label", _hoisted_14, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.status) = $event)),
                class: "hidden peer"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.status]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.status ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
              }, null, 2),
              _createElementVNode("span", {
                class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.status ? 'text-theme-green' : 'text-[#F53333]'])
              }, _toDisplayString(_ctx.form.status ? 'On' : 'Off'), 3)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-xs mb-1 mt-0" }, "Accept Online Orders:", -1)),
            _createElementVNode("label", _hoisted_16, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.acceptOnlineOrders) = $event)),
                class: "hidden peer"
              }, null, 512), [
                [_vModelCheckbox, _ctx.form.acceptOnlineOrders]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass('relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (_ctx.form.acceptOnlineOrders ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]'))
              }, null, 2),
              _createElementVNode("span", {
                class: _normalizeClass(["ml-2 text-white text-sm font-medium uppercase", _ctx.form.acceptOnlineOrders ? 'text-theme-green' : 'text-[#F53333]'])
              }, _toDisplayString(_ctx.form.acceptOnlineOrders ? 'On' : 'Off'), 3)
            ])
          ])
        ])
      ])
    ])
  ]))
}